var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronLeftIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.2 3.063 6.173 8.002l5.025 4.937L10.118 14 4 8l6.118-6z"
})));
export { SvgChevronLeftIcon as ReactComponent };
export default __webpack_public_path__ + "2b5cc4c3ddfd07410395c5341201d408.svg";